import store from '@/store/index'
import { getToken } from '@/util/auth'

/**
 * 登录态以登录凭证（token cookie）为准，不能以 name 为准。
 *
 * name 是 getInfo 拉取后用于顶栏展示的手机号，刷新时依赖 localStorage 持久化恢复：
 * 持久化状态缺失（被清理 / 未写入）时 name 为空，但 token cookie 仍然有效——
 * 接口带着 token 能正常返回数据（订单列表照常渲染），此时若用 name 判定，
 * 会把已登录用户误判成未登录，路由守卫随即弹出登录框（线上反馈的 bug）。
 */
export function isLogin() {
  return !!getToken()
}

export function showLogin() {
  store.commit('user/SET_LOGINVISIBLE', true)
}
